export const groupByBusiness = (arr) =>
  arr.reduce((prev, current) => {
    prev[current.business._id] = prev[current.business._id] ?? []
    prev[current.business._id].push(current)
    return prev
  }, {})
